import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';
import { isRescueTroubleCallType } from '../../../utils/helper';
import { noChargeDwellingTypes } from '../../../constants/dwellingTypes';

export const serviceTypeNeedsTruckRollCharge = (serviceTypeId) => {

    if (serviceTypeId && serviceTypeId.toLowerCase().includes('tc')) {
        return true;
    }
    return false;
};

export default (state, orderId) => {

    let currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;

    const currentCharges = state.getIn(['workOrderDetails', orderId, 'charges', 'details']);
    const orderStatus = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'orderStatus'
    ]);

    const serviceTypeId = state.getIn([
        'workOrderDetails',
        orderId,
        'schedulingSystemDetails',
        'details',
        'serviceOrderInfoV2',
        'serviceTypeId'
    ]);

    const dwellingType = state.getIn([
        'workOrderDetails',
        orderId,
        'customerDetails',
        'details',
        'dwellingType'
    ]);

    let allChargeItemsValid = true;
    let hasSpp = true,
        hasTruckRollCharge = false;

    if (currentCharges) {
        currentCharges.forEach((item) => {
            if (!item.get('isValid') || (item.get('hasUnsavedChanges') && item.get('requiresComment'))) {
                allChargeItemsValid = false;
            }

            if (item.get('chargeGroup') === 'spp' && (!item.get('quantity') || item.get('quantity') === 0)) {
                hasSpp = false;
            }

            if (item.get('chargeGroup') === 'serviceCallFee' && item.get('quantity') > 0) {
                hasTruckRollCharge = true;
            }

        });
    }

    // If the dwellingType is not included on the dwellingType array
    if(!noChargeDwellingTypes.includes(dwellingType)) {
        if (!allChargeItemsValid) {
          currentValidation = currentValidation.setIn([
            'charges', 'isValid'
          ], false).setIn([
            'charges', 'message'
          ], 'One or more charges are invalid.');
        }

        // if order status is complete, the customer does not have spp a charge option
        // must be selected.
        if ((!hasSpp && !hasTruckRollCharge && orderStatus === 'Complete') && serviceTypeNeedsTruckRollCharge(serviceTypeId) && !isRescueTroubleCallType(serviceTypeId)) {
        currentValidation = currentValidation.setIn([
          'charges', 'isValid'
        ], false).setIn([
          'charges', 'message'
        ], 'Tech visit charge selection is required.');
      }
    }

    return currentValidation;
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/chargesValidator.js